import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0020',
    ecrans: ['00-2'],
    params:['asgcleint']
});
